export default __webpack_public_path__ + "static/media/lockpad-light.cb9dc3a4.png";